import { AutoComplete, Tag, Tooltip } from "antd";
import { useEffect, useState } from "react";
import useDebounce from "../UseDebounce/useDebounce";
import { getSearchUnits } from "Explore/Services/Unit";

const AutoCompleteFilters = ({
  placeholder,
  institutionName,
  form,
  style,
  disabled,
  tagColor = "",
}) => {
  const [query, setQuery] = useState("");
  const [options, setOptions] = useState([]);
  const debouncedValue = useDebounce(query);

  useEffect(() => {
    if (debouncedValue) {
      const payload = {
        query: debouncedValue,
        institution_name_ls: [institutionName],
      };
      getSearchUnits(payload, (res) => {
        const options_list = res.results.map((item) => {
          return {
            ...item,
            value: item.name,
            label: item.name,
          };
        });
        setOptions(options_list);
      });
    }
  }, [debouncedValue]);
  const tagRender = (label) => {
    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    const onCloseTag = () => {
      const list = form
        .getFieldValue("department")
        .filter((item) => item !== label);
      form.setFieldValue("department", list);
    };
    const isLongTag = label.length > 30;
    const tagElem = (
      <Tag
        onMouseDown={onPreventMouseDown}
        closable
        onClose={onCloseTag}
        color={tagColor ? tagColor : ""}
      >
        {isLongTag ? `${label.slice(0, 15)}...` : label}
      </Tag>
    );
    return (
      <>{isLongTag ? <Tooltip title={label}>{tagElem}</Tooltip> : tagElem}</>
    );
  };
  const handleInputSearch = (value) => {
    setQuery(value);
  };
  const handleInputConfirm = (value, option) => {
    form.setFieldValue(
      "department",
      form.getFieldValue("department")
        ? [...form.getFieldValue("department"), `${option.value}`]
        : [`${option.value}`]
    );
    setQuery("");
  };

  return (
    <div>
      <AutoComplete
        disabled={disabled}
        value={query}
        options={options}
        placeholder={placeholder}
        onSearch={handleInputSearch}
        onSelect={handleInputConfirm}
        style={style ? style : { width: "100%" }}
      ></AutoComplete>
      <div className="keywords">
        {form.getFieldValue("department") &&
          form.getFieldValue("department").map((key) => tagRender(key))}
      </div>
    </div>
  );
};

export default AutoCompleteFilters;
